import { Injectable } from '@angular/core';
import { CommonHttpService } from 'src/app/utils/common-http.service';
import { HttpClient } from '@angular/common/http';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttperrorhandlerService } from '../../shared/http/httperrorhandler.service';
import { isNullOrUndefined } from 'util';
import { DatePipe } from '@angular/common';
import { isEmptyField } from '../../shared/stock-chart-module/stock-chart/stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { environment } from 'src/environments/environment';
import * as L from 'leaflet';

@Injectable({
  providedIn: 'root'
})
export class HeatIndexDataService {
  mandalData: Object;
  urlConstants = environment.url;

  constructor(
    private http: HttpClient,
    private utils: UtilsService,
    private errorHandler: HttperrorhandlerService,
    private datepipe: DatePipe
  ) { }

  getMandalData(url, postData) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(ProjConstants.API_URL + url, postData).subscribe(data => {
        this.mandalData = data;
        resolve(data);
      },
        err => {
          reject(err);
        }
      );
    })
    return promise;
  }

  getActualData(url, postData) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(ProjConstants.API_URL + url, postData).subscribe(data => {
        this.mandalData = data;
        resolve(data);
      },
        err => {
          reject(err);
        }
      );
    })
    return promise;
  }

  getAccuracyData(url, postData) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(ProjConstants.API_URL + url, postData).subscribe(data => {
        // this.mandalData = data;
        resolve(data);
      },
        err => {
          reject(err);
        }
      );
    })
    return promise;
  }

  getDistrictData(url, postData) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(ProjConstants.API_URL + url, postData).subscribe(data => {
        this.mandalData = data;
        resolve(data);
      },
        err => {
          reject(err);
        }
      );
    })
    return promise;
  }
  getStateData(url, postData) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(ProjConstants.API_URL + url, postData).subscribe(data => {
        this.mandalData = data;
        resolve(data);
      },
        err => {
          reject(err);
        }
      );
    })
    return promise;
  }

  getOverallAccuracy(url, postData) {
    let promise = new Promise((resolve, reject) => {
      this.http.post(ProjConstants.API_URL + url, postData).subscribe(data => {
        this.mandalData = data;
        resolve(data);
      },
        err => {
          reject(err);
        }
      );
    })
    return promise;
  }

  formatDistrictData(data, actualData?, accuracyData?) {
    let finalData = {};
    let timeStampList = []
    let table_data = []
    let currentDate = this.getCurrentDateInYYYYMMDDFormat();
    let formattedActualData = this.formatAccuracyData(actualData, accuracyData)
    let foramtted = this.fetchTotData(data,actualData);
    for (let locName in foramtted) {
      let locObject = {}
      locObject['District'] = { val: this.utils.formatNames(foramtted[locName]['name']) };
      locObject['uuid'] = (foramtted[locName]['uuid']);
      for (let element in foramtted[locName]['table_data']) {
        if (foramtted[locName]['table_data'][element]['data'] == null || foramtted[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = foramtted[locName]['table_data'][element]['timeStamp'];
        if(timeStamp >= currentDate) {
          let accuracy = formattedActualData[locName]['table_data'][0]['data']['a']
          if (!timeStampList.includes(timeStamp)) {
            timeStampList.push(timeStamp);
          }
          if (timeStamp == currentDate) {
            let timeC = timeStamp.toString() + "_" + "c";
            locObject[timeC] = { val: formattedActualData[locName]['table_data'][element] ? formattedActualData[locName]['table_data'][element]['data']['c'] : '-'};
            let timeD = timeStamp.toString() + "_" + "d";
            locObject[timeD] = { val: formattedActualData[locName]['table_data'][element] ? formattedActualData[locName]['table_data'][element]['data']['d'] : '-'};
            if (timeStamp == currentDate) {
              let timeE = timeStamp.toString() + "_" + "a";
              locObject[timeE] = { val: accuracy };
            }
          } else {
            let timeC = timeStamp.toString() + "_" + "c";
            locObject[timeC] = { val: foramtted[locName]['table_data'][element]['data']['c'] };
            let timeD = timeStamp.toString() + "_" + "d";
            locObject[timeD] = { val: foramtted[locName]['table_data'][element]['data']['d'] };
            // if(timeStamp == currentDate) {
            //   let timeE = timeStamp.toString() + "_" + "ac";
            //   locObject[timeE] = { val : data[locName]['table_data'][element]['data']['ac']};
            // }
          }
        }
      }
      // console.log(data[locName]);
      if (foramtted[locName]['centroid'] != undefined && foramtted[locName]['centroid'] != null) {
        locObject['centroid'] = foramtted[locName]['centroid'];
      }
      table_data.push(locObject);
    }
    table_data.sort((a, b) => {
      let sumA =  (a[currentDate + '_d'].val || 0)
      let sumB =  (b[currentDate + '_d'].val || 0)
      return sumB - sumA;
    });
    let sortedTimeStampList = timeStampList.sort()
    let column1 = [];
    column1.push({
      val: 'District',
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: 'District',
    })
    let column2 = [];
    let tableHeaders = [];
    tableHeaders.push({ val: 'District' });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      column1.push({
        val: tp == currentDate ? this.utils.convertModelDatetoDate(tp).toLocaleDateString() + ' (' + 'Observed' + ')' : this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: tp == currentDate ? 3 : 2,
        rowspan: 1,
        sortedHeaderVal: tp.toString() + "_d"
      })
      column2.push({
        val: 'Heatwave',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
        sortedHeaderVal: tp.toString() + "_c"
      })
      column2.push({
        val: 'Severe Heatwave',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
        sortedHeaderVal: tp.toString() + "_d"
      })
      if (tp == currentDate) {
        column2.push({
          val: 'Accuracy (%)',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.Accuracy,
          sortedHeaderVal: tp.toString() + "_a"
        })
      }
      tableHeaders.push({
        val: tp.toString() + "_c"
      })
      tableHeaders.push({
        val: tp.toString() + "_d"
      })
      if (tp == currentDate) {
        tableHeaders.push({
          val: tp.toString() + "_a"
        })
      }
    }
    let tableColumns = []
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_data;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatDistrictData2(data) {
    let finalData = {};
    let timeStampList = []
    let table_data = []
    for (let locName in data) {
      let locObject = {}
      locObject['District'] = { val: this.utils.formatNames(data[locName]['name']) };
      locObject['uuid'] = (data[locName]['uuid']);
      for (let element in data[locName]['table_data']) {
        if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if (!timeStampList.includes(timeStamp)) {
          timeStampList.push(timeStamp);
        }
        let timeC = timeStamp.toString() + "_" + "vh";
        locObject[timeC] = { val: data[locName]['table_data'][element]['data']['vh'] };
        let timeD = timeStamp.toString() + "_" + "h";
        locObject[timeD] = { val: data[locName]['table_data'][element]['data']['h'] };
        let timeE = timeStamp.toString() + "_" + "w";
        locObject[timeE] = { val: data[locName]['table_data'][element]['data']['w'] };
        let timeF = timeStamp.toString() + "_" + "sw";
        locObject[timeF] = { val: data[locName]['table_data'][element]['data']['sw'] };
        let timeG = timeStamp.toString() + "_" + "n";
        locObject[timeG] = { val: data[locName]['table_data'][element]['data']['n'] };
      }
      // console.log(data[locName]);
      if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_data.push(locObject);
    }
    let sortedTimeStampList = timeStampList.sort()
    let column1 = [];
    column1.push({
      val: 'District',
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: 'District',
    })
    let column2 = [];
    let tableHeaders = [];
    tableHeaders.push({ val: 'District' });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      column1.push({
        val: this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: 5,
        rowspan: 1,
        sortedHeaderVal: tp.toString() + "_h"
      })
      column2.push({
        val: 'Extreme Danger',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.very_hot,
        sortedHeaderVal: tp.toString() + "_vh"
      })
      column2.push({
        val: 'Danger',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.hot,
        sortedHeaderVal: tp.toString() + "_h"
      })
      column2.push({
        val: 'Extreme Caution',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.warm,
        sortedHeaderVal: tp.toString() + "_w"
      })
      column2.push({
        val: 'Caution',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.slightly_warm,
        sortedHeaderVal: tp.toString() + "_sw"
      })
      column2.push({
        val: 'Normal',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.normal,
        sortedHeaderVal: tp.toString() + "_n"
      })
      tableHeaders.push({
        val: tp.toString() + "_vh"
      })
      tableHeaders.push({
        val: tp.toString() + "_h"
      })
      tableHeaders.push({
        val: tp.toString() + "_w"
      })
      tableHeaders.push({
        val: tp.toString() + "_sw"
      })
      tableHeaders.push({
        val: tp.toString() + "_n"
      })
    }
    let tableColumns = []
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_data;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }
  getCurrentDateInYYYYMMDDFormat() {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();

    let displayDate;

    if (currentHour > 17 || (currentHour === 17 && currentMinutes >= 30)) {
      // After 5:30 PM
      displayDate = currentDate;
    } else {
      // Before 5:30 PM
      const yesterday = new Date(currentDate);
      yesterday.setDate(currentDate.getDate() - 1); // Set date to yesterday
      displayDate = yesterday;
    }

    const year = displayDate.getFullYear();
    const month = String(displayDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(displayDate.getDate()).padStart(2, '0');

    const formattedDate = `${year}${month}${day}`;
    return formattedDate
  }
  getCurrentDateInYYYYMMDDFormat1() {
    const currentDate = new Date();
    const threeDaysAgo = new Date(currentDate);
    threeDaysAgo.setDate(currentDate.getDate() - 3); // Set date to three days ago

    const year = threeDaysAgo.getFullYear();
    const month = String(threeDaysAgo.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(threeDaysAgo.getDate()).padStart(2, '0');

    const formattedDate = `${year}${month}${day}`;
    return formattedDate;
}
  formatStateData(data, actualData, accuracyData) {
    if (!isNullOrUndefined(data) && !isNullOrUndefined(actualData)) {
      let finalData = {};
      let timeStampList = []
      let table_data = []
      let formattedActualData = this.formatAccuracyData(actualData, accuracyData)
      let foramtted = this.fetchTotData(data,actualData);
      let currentDate = this.getCurrentDateInYYYYMMDDFormat();
      for (let locName in foramtted) {
        let locObject = {}
        locObject['State'] = { val: this.utils.formatNames(foramtted[locName]['name']) };
        locObject['uuid'] = foramtted[locName]['uuid'];
        for (let element in foramtted[locName]['table_data']) {
          if (foramtted[locName]['table_data'][element]['data'] == null || foramtted[locName]['table_data'][element]['data'] == undefined) {
            continue;
          }
          let timeStamp = foramtted[locName]['table_data'][element]['timeStamp'].toString();
          if(timeStamp >= currentDate) {
          let accuracy = formattedActualData[locName]['table_data'][0]['data']['a']
          // let timeStamp = element['timeStamp'];
          if (!timeStampList.includes(timeStamp)) {
            timeStampList.push(timeStamp);
          }
          if (timeStamp == currentDate) {
            let timeC = timeStamp.toString() + "_" + "c";
            locObject[timeC] = { val: formattedActualData[locName]['table_data'][element] ? formattedActualData[locName]['table_data'][element]['data']['c'] : '-' };
            let timeD = timeStamp.toString() + "_" + "d";
            locObject[timeD] = { val: formattedActualData[locName]['table_data'][element] ? formattedActualData[locName]['table_data'][element]['data']['d'] : '-' };
            // if(timeStamp == currentDate) {
            let timeE = timeStamp.toString() + "_" + "a";
            locObject[timeE] = { val: accuracy };
            // }
          } else {
            let timeC = timeStamp.toString() + "_" + "c";
            locObject[timeC] = { val: foramtted[locName]['table_data'][element]['data']['c'] };
            let timeD = timeStamp.toString() + "_" + "d";
            locObject[timeD] = { val: foramtted[locName]['table_data'][element]['data']['d'] };
            // if(timeStamp == currentDate) {
            //   let timeE = timeStamp.toString() + "_" + "ac";
            //   locObject[timeE] = { val : data[locName]['table_data'][element]['data']['ac']};
            // }
          }
          }
        }
        // console.log(data[locName]);
        if (foramtted[locName]['centroid'] != undefined && foramtted[locName]['centroid'] != null) {
          locObject['centroid'] = foramtted[locName]['centroid'];
        }
        table_data.push(locObject);
        table_data.sort((a, b) => {
          let sumA = (a[currentDate + '_c'].val || 0) + (a[currentDate + '_d'].val || 0);
          let sumB = (b[currentDate + '_c'].val || 0) + (b[currentDate + '_d'].val || 0);
          return sumB - sumA;
        });
      }
      let sortedTimeStampList = timeStampList.sort()
      let column1 = [];
      column1.push({
        val: 'State / UT',
        colspan: 1,
        rowspan: 2,
        sortedHeaderVal: 'State',
      })
      let column2 = [];
      let tableHeaders = [];
      tableHeaders.push({ val: 'State' });
      for (let index in sortedTimeStampList) {
        let tp = sortedTimeStampList[index];
        column1.push({
          val: tp == currentDate ? this.utils.convertModelDatetoDate(tp).toLocaleDateString() + ' (' + 'Observed' + ')' : this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
          colspan: tp == currentDate ? 3 : 2,
          rowspan: 1,
          sortedHeaderVal: tp.toString() + "_d"
        })
        column2.push({
          val: 'Heatwave',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
          sortedHeaderVal: tp.toString() + "_c"
        })
        column2.push({
          val: 'Severe Heatwave',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.severe_heat_waves,
          sortedHeaderVal: tp.toString() + "_d"
        })
        if (tp == currentDate) {
          column2.push({
            val: 'Accuracy (%)',
            colspan: 1,
            rowspan: 1,
            backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.Accuracy,
            sortedHeaderVal: tp.toString() + "_a"
          })
        }
        tableHeaders.push({
          val: tp.toString() + "_c"
        })
        tableHeaders.push({
          val: tp.toString() + "_d"
        })
        if (tp == currentDate) {
          tableHeaders.push({
            val: tp.toString() + "_a"
          })
        }
      }
      let tableColumns = []
      tableColumns.push(column1);
      tableColumns.push(column2);
      finalData['data'] = table_data;
      finalData['columns'] = tableColumns;
      finalData['tableHeaders'] = tableHeaders;
      return finalData;
    }
  }
  formatStateData2(data) {
    let finalData = {};
    let timeStampList = []
    let table_data = []
    for (let locName in data) {
      let locObject = {}
      locObject['State'] = { val: this.utils.formatNames(data[locName]['name']) };
      locObject['uuid'] = data[locName]['uuid'];
      for (let element in data[locName]['table_data']) {
        if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if (!timeStampList.includes(timeStamp)) {
          timeStampList.push(timeStamp);
        }
        let timeC = timeStamp.toString() + "_" + "vh";
        locObject[timeC] = { val: data[locName]['table_data'][element]['data']['vh'] };
        let timeD = timeStamp.toString() + "_" + "h";
        locObject[timeD] = { val: data[locName]['table_data'][element]['data']['h'] };
        let timeE = timeStamp.toString() + "_" + "w";
        locObject[timeE] = { val: data[locName]['table_data'][element]['data']['w'] };
        let timeF = timeStamp.toString() + "_" + "sw";
        locObject[timeF] = { val: data[locName]['table_data'][element]['data']['sw'] };
        let timeG = timeStamp.toString() + "_" + "n";
        locObject[timeG] = { val: data[locName]['table_data'][element]['data']['n'] };
      }
      // console.log(data[locName]);
      if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_data.push(locObject);
    }
    let sortedTimeStampList = timeStampList.sort()
    let column1 = [];
    column1.push({
      val: 'State',
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: 'State',
    })
    let column2 = [];
    let tableHeaders = [];
    tableHeaders.push({ val: 'State' });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      column1.push({
        val: this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: 5,
        rowspan: 1,
        sortedHeaderVal: tp.toString() + "_h"
      })
      column2.push({
        val: 'Extreme Danger',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.very_hot,
        sortedHeaderVal: tp.toString() + "_vh",
        color: 'black'
      })
      column2.push({
        val: 'Danger',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
        sortedHeaderVal: tp.toString() + "_h"
      })
      column2.push({
        val: 'Extreme Caution',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.warm,
        sortedHeaderVal: tp.toString() + "_w"
      })
      column2.push({
        val: 'Caution',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.slightly_warm,
        sortedHeaderVal: tp.toString() + "_sw"
      })
      column2.push({
        val: 'Normal',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.normal,
        sortedHeaderVal: tp.toString() + "_n"
      })
      tableHeaders.push({
        val: tp.toString() + "_vh"
      })
      tableHeaders.push({
        val: tp.toString() + "_h"
      })
      tableHeaders.push({
        val: tp.toString() + "_w"
      })
      tableHeaders.push({
        val: tp.toString() + "_sw"
      })
      tableHeaders.push({
        val: tp.toString() + "_n"
      })
    }
    let tableColumns = []
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_data;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatMandalData(data, hval, hcat, actualData?, accuracyDataForMandal?, component?) {
    let finalData = {};
    let table_dataForMandal = [];
    let timeStampList = [];
    let currentDate = this.getCurrentDateInYYYYMMDDFormat()
    let accuracyData = this.fetchObj(accuracyDataForMandal);
    let foramtted = this.fetchTotData(data,actualData);
    for (let locName of Object.keys(data)) {
      if (data[locName]['table_data'] == null || data[locName]['table_data'] == undefined) {
        continue;
      }
      let locObject = {};
      let accuracyVal :any;
      for (let index of foramtted[locName]['table_data']) {
        if(index['timeStamp'] >= currentDate) {
          if (!timeStampList.includes(index['timeStamp'])) {
            timeStampList.push(index['timeStamp']);
          }
          if (index['timeStamp'] == currentDate) {
            for(let actualLocName of Object.keys(actualData)) {
              if (!(Number(actualData[actualLocName]['table_data'][0]['data'][hval]).toFixed(2) == "NaN") && actualData[actualLocName]['uuid'] == data[locName]['uuid']) {
                locObject[index['timeStamp']] = {
                  val: Number(actualData[actualLocName]['table_data'][0]['data'][hval]).toFixed(2),
                  backgroundColor: component == 'HEATINDEX' ? ProjConstants.DISCOMFORT_INDEX_LEGEND[index['data'][hcat]] : ProjConstants.HEAT_WATCHES_LEGEND[actualData[actualLocName]['table_data'][0]['data'][hcat]],
                  accuracy: accuracyData[data[locName]['uuid']]['table_data'][0]['data']['accuracy']
                }
                let c:any = index['timeStamp'].toString()+"_a";
                locObject[index['timeStamp']][c] = Number(accuracyData[data[locName]['uuid']]['table_data'][0]['data']['accuracy']* 100).toFixed(2)
              }
            }
          } else {
            if (!(Number(index['data'][hval]).toFixed(2) == "NaN")) {
              locObject[index['timeStamp']] = {
                val: Number(index['data'][hval]).toFixed(2),
                backgroundColor: component == 'HEATINDEX' ? ProjConstants.DISCOMFORT_INDEX_LEGEND[index['data'][hcat]] : ProjConstants.HEAT_WATCHES_LEGEND[index['data'][hcat]],
                // accuracy: accuracyData[data[locName]['uuid']]['table_data'][0]['data']['accuracy']
              }
            }
          }

        }
      }
      locObject['District'] = { val: this.utils.formatNames(data[locName]['pName']) }
      locObject['Mandal'] = { val: this.utils.formatNames(data[locName]['name']) }
      if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_dataForMandal.push(locObject)
    }
    let sortedTimeStampList = timeStampList.sort();
    let column1 = [];
    let column2 = []
    column1.push({
      val: 'Mandal',
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: 'Mandal',
    })
    column1.push({
      val: 'District',
      colspan: 1,
      rowspan: 1,
      sortedHeaderVal: 'District',
    })
    let tableHeaders = [];
    tableHeaders.push({ val: 'Mandal' });
    tableHeaders.push({ val: 'District' });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      let isFirst = parseInt(index) === 0;
      column1.push({
        val: tp == currentDate ? this.utils.convertModelDatetoDate(tp).toLocaleDateString()  : this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: tp == currentDate ? 2 : 1,
        rowspan: 1,
        sortedHeaderVal: tp.toString()
      })
      // if (tp == currentDate) {
        column2.push({
        // val: 'Observed',
        val: isFirst ? 'Observed' : 'Forecast',
          colspan: 1,
          rowspan: 1,
          // backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.heat_waves,
          // sortedHeaderVal: tp.toString() + "_c"
        })
      // }
      if (tp == currentDate) {
        column2.push({
          val: 'Accuracy (%)',
          colspan: 1,
          rowspan: 1,
          backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.Accuracy,
          sortedHeaderVal: tp.toString() + "_a"
        })
        // column2.push({
        //   val: 'Accuracy',
        //   colspan: 1,
        //   rowspan: 1,
        //   backgroundColor: ProjConstants.HEAT_WATCHES_LEGEND.Accuracy,
        //   sortedHeaderVal: 'accuracy'
        // })
      }
      tableHeaders.push({
        val: tp.toString()
      })
      if (tp == currentDate) {
        tableHeaders.push({
          val: tp
        })
      }
    }
    let tableColumns = []
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_dataForMandal;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }
  formatMandalData2(data, hval, hcat, component?) {
    let finalData = {};
    let table_dataForMandal = [];
    let timeStampList = [];
    for (let locName of Object.keys(data)) {
      if (data[locName]['table_data'] == null || data[locName]['table_data'] == undefined) {
        continue;
      }
      let locObject = {};
      for (let index of data[locName]['table_data']) {
        if (!timeStampList.includes(index['timeStamp'])) {
          timeStampList.push(index['timeStamp']);
        }
        if (!(Number(index['data'][hval]).toFixed(2) == "NaN")) {
          locObject[index['timeStamp']] = {
            val: Number(index['data'][hval]).toFixed(2),
            backgroundColor: component == 'HEATINDEX' ? ProjConstants.HEAT_INDEX_LEGEND[index['data'][hcat]] : ProjConstants.HEAT_WATCHES_LEGEND[index['data'][hcat]],


          }
        }
      }
      locObject['District'] = { val: this.utils.formatNames(data[locName]['pName']) }
      locObject['Mandal'] = { val: this.utils.formatNames(data[locName]['name']) }
      if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_dataForMandal.push(locObject)
    }
    let sortedTimeStampList = timeStampList.sort();
    let column1 = [];
    column1.push({
      val: 'Mandal',
      colspan: 1,
      rowspan: 1,
      sortedHeaderVal: 'Mandal',
    })
    column1.push({
      val: 'District',
      colspan: 1,
      rowspan: 1,
      sortedHeaderVal: 'District',
    })
    let tableHeaders = [];
    tableHeaders.push({ val: 'Mandal' });
    tableHeaders.push({ val: 'District' });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      column1.push({
        val: this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: tp.toString()
      })
      tableHeaders.push({
        val: tp.toString()
      })
    }
    let tableColumns = []
    tableColumns.push(column1);
    finalData['data'] = table_dataForMandal;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatChartData(data, chartDataString, actualData?) {
    let timeStampList = []
    let blockArray = []
    let formattedChartData = [{}, {}, {}];
    formattedChartData[0][chartDataString] = "Severe Heatwave";
    formattedChartData[1][chartDataString] = "Heatwave";
    formattedChartData[2][chartDataString] = "Normal";
    // formattedChartData[3][chartDataString] = "Accuracy";

    let chartData = {
      "SevereHeatwave": {},
      "Heatwave": {},
      "Normal": {}
    };
    let count = 0
    let currentDate = this.getCurrentDateInYYYYMMDDFormat();
    for (let locName in data) {
      let locObject = {}
      for (let element in data[locName]['table_data']) {
        if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if (!timeStampList.includes(timeStamp)) {
          timeStampList.push(timeStamp);
        }
        let date = this.utils.convertModelDatetoDate(timeStamp).toLocaleDateString();
        if (timeStamp == currentDate) {
          if (chartData["SevereHeatwave"][date] == undefined && formattedChartData[0][date] == undefined) {
            chartData["SevereHeatwave"][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['d'];
            formattedChartData[0][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['d'];;
          }
          else {
            chartData["SevereHeatwave"][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['d'];;
            formattedChartData[0][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['d'];;
          }
          if (chartData["Heatwave"][date] == undefined && formattedChartData[1][date] == undefined) {
            chartData["Heatwave"][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['c'];
            formattedChartData[1][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['c'];
          }
          else {
            chartData["Heatwave"][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['c'];
            formattedChartData[1][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['c'];
          }
          if (chartData["Normal"][date] == undefined && formattedChartData[2][date] == undefined) {
            chartData["Normal"][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['n'];
            formattedChartData[2][date] = actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['n'];
          }
          else {
            chartData["Normal"][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['n'];
            formattedChartData[2][date] += actualData[locName]['table_data'][actualData[locName]['table_data'].length -1]['data']['n'];
          }
        } else {
          if (chartData["SevereHeatwave"][date] == undefined && formattedChartData[0][date] == undefined) {
            chartData["SevereHeatwave"][date] = data[locName]['table_data'][element]['data']['d'];
            formattedChartData[0][date] = data[locName]['table_data'][element]['data']['d'];
          }
          else {
            chartData["SevereHeatwave"][date] += data[locName]['table_data'][element]['data']['d'];
            formattedChartData[0][date] += data[locName]['table_data'][element]['data']['d'];
          }
          if (chartData["Heatwave"][date] == undefined && formattedChartData[1][date] == undefined) {
            chartData["Heatwave"][date] = data[locName]['table_data'][element]['data']['c'];
            formattedChartData[1][date] = data[locName]['table_data'][element]['data']['c'];
          }
          else {
            chartData["Heatwave"][date] += data[locName]['table_data'][element]['data']['c'];
            formattedChartData[1][date] += data[locName]['table_data'][element]['data']['c'];
          }
          if (chartData["Normal"][date] == undefined && formattedChartData[2][date] == undefined) {
            chartData["Normal"][date] = data[locName]['table_data'][element]['data']['n'];
            formattedChartData[2][date] = data[locName]['table_data'][element]['data']['n'];
          }
          else {
            chartData["Normal"][date] += data[locName]['table_data'][element]['data']['n'];
            formattedChartData[2][date] += data[locName]['table_data'][element]['data']['n'];
          }
        }
        // if(chartData["Accuracy"][date] == undefined && formattedChartData[3][date] == undefined){
        //   chartData["Accuracy"][date] = data[locName]['table_data'][element]['data']['n'];
        //   formattedChartData[3][date] = data[locName]['table_data'][element]['data']['n'];
        // }
        // else{
        //   chartData["Accuracy"][date] += data[locName]['table_data'][element]['data']['n'];
        //   formattedChartData[3][date] += data[locName]['table_data'][element]['data']['n'];
        // }
      }
      count = count + 1;
    }
    let sortedTimeStampList = timeStampList.sort()
    for (let tp of sortedTimeStampList) {
      blockArray.push(this.utils.convertModelDatetoDate(tp).toLocaleDateString());
    }
    return [chartData, formattedChartData, blockArray, count];
  }
  formatChartData2(data, chartDataString) {
    let timeStampList = []
    let blockArray = []
    let formattedChartData = [{}, {}, {}, {}, {}];
    formattedChartData[0][chartDataString] = "Extreme Danger";
    formattedChartData[1][chartDataString] = "Danger";
    formattedChartData[2][chartDataString] = "Extreme Caution";
    formattedChartData[3][chartDataString] = "Caution";
    formattedChartData[4][chartDataString] = "Normal";
    let chartData = {
      "ExtremeDanger": {},
      "Danger": {},
      "ExtremeCaution": {},
      "Caution": {},
      "Normal": {}
    };
    let count = 0;
    for (let locName in data) {
      let locObject = {}
      for (let element in data[locName]['table_data']) {
        if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if (!timeStampList.includes(timeStamp)) {
          timeStampList.push(timeStamp);
        }
        let date = this.utils.convertModelDatetoDate(timeStamp).toLocaleDateString();
        if (chartData["ExtremeDanger"][date] == undefined && formattedChartData[0][date] == undefined) {
          chartData["ExtremeDanger"][date] = data[locName]['table_data'][element]['data']['vh'];
          formattedChartData[0][date] = data[locName]['table_data'][element]['data']['vh'];
        }
        else {
          chartData["ExtremeDanger"][date] += data[locName]['table_data'][element]['data']['vh'];
          formattedChartData[0][date] += data[locName]['table_data'][element]['data']['vh'];
        }
        if (chartData["Danger"][date] == undefined && formattedChartData[1][date] == undefined) {
          chartData["Danger"][date] = data[locName]['table_data'][element]['data']['h'];
          formattedChartData[1][date] = data[locName]['table_data'][element]['data']['h'];
        }
        else {
          chartData["Danger"][date] += data[locName]['table_data'][element]['data']['h'];
          formattedChartData[1][date] += data[locName]['table_data'][element]['data']['h'];
        }
        if (chartData["ExtremeCaution"][date] == undefined && formattedChartData[2][date] == undefined) {
          chartData["ExtremeCaution"][date] = data[locName]['table_data'][element]['data']['w'];
          formattedChartData[2][date] = data[locName]['table_data'][element]['data']['w'];
        }
        else {
          chartData["ExtremeCaution"][date] += data[locName]['table_data'][element]['data']['w'];
          formattedChartData[2][date] += data[locName]['table_data'][element]['data']['w'];
        }
        if (chartData["Caution"][date] == undefined && formattedChartData[3][date] == undefined) {
          chartData["Caution"][date] = data[locName]['table_data'][element]['data']['sw'];
          formattedChartData[3][date] = data[locName]['table_data'][element]['data']['sw'];
        }
        else {
          chartData["Caution"][date] += data[locName]['table_data'][element]['data']['sw'];
          formattedChartData[3][date] += data[locName]['table_data'][element]['data']['sw'];
        }
        if (chartData["Normal"][date] == undefined && formattedChartData[4][date] == undefined) {
          chartData["Normal"][date] = data[locName]['table_data'][element]['data']['n'];
          formattedChartData[4][date] = data[locName]['table_data'][element]['data']['n'];
        }
        else {
          chartData["Normal"][date] += data[locName]['table_data'][element]['data']['n'];
          formattedChartData[4][date] += data[locName]['table_data'][element]['data']['n'];
        }
      }
      count = count + 1;
    }
    let sortedTimeStampList = timeStampList.sort()
    for (let tp of sortedTimeStampList) {
      blockArray.push(this.utils.convertModelDatetoDate(tp).toLocaleDateString());
    }
    return [chartData, formattedChartData, blockArray, count];
  }

  formatDiscomfortIndexChartData(data, chartDataString) {
    let timeStampList = []
    let blockArray = []
    let formattedChartData = [{}, {}, {}];
    formattedChartData[0][chartDataString] = "Very Hot";
    formattedChartData[1][chartDataString] = "Hot";
    formattedChartData[2][chartDataString] = "Warm";
    let chartData = {
      "very_hot": {},
      "hot": {},
      "warm": {}
    };
    for (let locName in data) {
      let locObject = {}
      for (let element in data[locName]['table_data']) {
        if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if (!timeStampList.includes(timeStamp)) {
          timeStampList.push(timeStamp);
        }
        let date = this.utils.convertModelDatetoDate(timeStamp).toLocaleDateString();
        if (chartData["very_hot"][date] == undefined && formattedChartData[0][date] == undefined) {
          chartData["very_hot"][date] = data[locName]['table_data'][element]['data']['d'];
          formattedChartData[0][date] = data[locName]['table_data'][element]['data']['d'];
        }
        else {
          chartData["very_hot"][date] += data[locName]['table_data'][element]['data']['d'];
          formattedChartData[0][date] += data[locName]['table_data'][element]['data']['d'];
        }
        if (chartData["hot"][date] == undefined && formattedChartData[1][date] == undefined) {
          chartData["hot"][date] = data[locName]['table_data'][element]['data']['c'];
          formattedChartData[1][date] = data[locName]['table_data'][element]['data']['c'];
        }
        else {
          chartData["hot"][date] += data[locName]['table_data'][element]['data']['c'];
          formattedChartData[1][date] += data[locName]['table_data'][element]['data']['c'];
        }
        if (chartData["warm"][date] == undefined && formattedChartData[2][date] == undefined) {
          chartData["warm"][date] = data[locName]['table_data'][element]['data']['n'];
          formattedChartData[2][date] = data[locName]['table_data'][element]['data']['n'];
        }
        else {
          chartData["warm"][date] += data[locName]['table_data'][element]['data']['n'];
          formattedChartData[2][date] += data[locName]['table_data'][element]['data']['n'];
        }
      }
    }
    let sortedTimeStampList = timeStampList.sort()
    for (let tp of sortedTimeStampList) {
      blockArray.push(this.utils.convertModelDatetoDate(tp).toLocaleDateString());
    }
    return [chartData, formattedChartData, blockArray];
  }

  formatDiscomfortIndexDistrictData(data) {
    let finalData = {};
    let timeStampList = []
    let table_data = []
    for (let locName in data) {
      let locObject = {}
      locObject['District'] = { val: this.utils.formatNames(data[locName]['name']) };
      for (let element in data[locName]['table_data']) {
        if (data[locName]['table_data'][element]['data'] == null || data[locName]['table_data'][element]['data'] == undefined) {
          continue;
        }
        let timeStamp = data[locName]['table_data'][element]['timeStamp'];
        if (!timeStampList.includes(timeStamp)) {
          timeStampList.push(timeStamp);
        }
        let timeC = timeStamp.toString() + "_" + "c";
        locObject[timeC] = { val: data[locName]['table_data'][element]['data']['c'] };
        let timeD = timeStamp.toString() + "_" + "d";
        locObject[timeD] = { val: data[locName]['table_data'][element]['data']['d'] };
        let timeN = timeStamp.toString() + "_" + "n";
        locObject[timeN] = { val: data[locName]['table_data'][element]['data']['n'] };
      }
      // console.log(data[locName]);
      if (data[locName]['centroid'] != undefined && data[locName]['centroid'] != null) {
        locObject['centroid'] = data[locName]['centroid'];
      }
      table_data.push(locObject);
    }
    let sortedTimeStampList = timeStampList.sort()
    let column1 = [];
    column1.push({
      val: 'District',
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: 'District',
    })
    let column2 = [];
    let tableHeaders = [];
    tableHeaders.push({ val: 'District' });
    for (let index in sortedTimeStampList) {
      let tp = sortedTimeStampList[index];
      column1.push({
        val: this.utils.convertModelDatetoDate(tp).toLocaleDateString(),
        colspan: 3,
        rowspan: 1,
        sortedHeaderVal: tp.toString() + "_d"
      })
      column2.push({
        val: 'VH',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.very_hot,
        sortedHeaderVal: tp.toString() + "_d"
      })
      column2.push({
        val: 'H',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.hot,
        sortedHeaderVal: tp.toString() + "_c"
      })

      column2.push({
        val: 'W',
        colspan: 1,
        rowspan: 1,
        backgroundColor: ProjConstants.DISCOMFORT_INDEX_LEGEND.warm,
        sortedHeaderVal: tp.toString() + "_n"
      })
      tableHeaders.push({
        val: tp.toString() + "_c"
      })
      tableHeaders.push({
        val: tp.toString() + "_d"
      })
      tableHeaders.push({
        val: tp.toString() + "_n"
      })
    }
    let tableColumns = []
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_data;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    return finalData;
  }

  formatAccuracyData(actualData, accuracyData) {
    let formattedData = this.fetchObj(this.fetchTotData(actualData, accuracyData));
    let currentDate = this.getCurrentDateInYYYYMMDDFormat()
    for (let i in actualData) {
      if (formattedData[actualData[i]['uuid']]) {
        let val: any = formattedData[actualData[i]['uuid']];

        actualData[i]['table_data'][0]['data']['a'] = (((this.fetchData(currentDate, val['table_data'])) * 100).toFixed(2))
      }
    }
    return actualData
  }

  fetchData(date: any, data: any) {
    for (let i: any = 0; i < data.length; i++) {
      if (data[i]['timeStamp'] == date) {
        return data[i]['data']['accuracy']
      }
    }

    return '-';
  }

  formatOverallAccuracyData(data) {
    let currentDate = this.getCurrentDateInYYYYMMDDFormat()
    // if (data.length > 0) {
    //   let accuracyData = ((data[0]['table_data'][currentDate]['accuracy']) * 100).toFixed(2);
    //   return accuracyData;
    // }
      if (data.length > 0) {
      let accuracyData = null;
      for (let i = 0; i < data[0]['table_data'].length; i++) {
          let tableDataItem = data[0]['table_data'][i];
          let timeStamp = tableDataItem['timeStamp'].toString();
          let tableDataDate = timeStamp.substring(0, 8);
          if (tableDataDate === currentDate) {
              accuracyData = (tableDataItem['data']['accuracy'] * 100).toFixed(2);
              break;
          }
      }
      return accuracyData;
  } else {
      return null; // or handle the case when data is empty
  }
  }

  getOverallAccuracyDataForState(actualData, stateUUID) {
    for (let i in actualData) {
      if (actualData[i].uuid == stateUUID) {
        let accuracyData = actualData[i]['table_data'][0]['data']['a'];
        return accuracyData
      }
    }
  }

  getLast7DaysDates() {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();

    let displayDate;
    let dateIndex;

    if (currentHour > 17 || (currentHour === 17 && currentMinutes >= 30)) {
      // After 5:30 PM
      // displayDate = currentDate;
      dateIndex = 10;
    } else {
      // Before 5:30 PM
      // const yesterday = new Date(currentDate);
      // yesterday.setDate(currentDate.getDate() - 3); // Set date to yesterday
      // displayDate = yesterday;
      dateIndex = 9;
    }
    const yesterday = new Date(currentDate);
    yesterday.setDate(currentDate.getDate() - 3); // Set date to yesterday
    displayDate = yesterday;
    let dateBlockNumMap = {};
    for (let i = 0; i < dateIndex; ++i) {
      dateBlockNumMap[
        this.datepipe.transform(displayDate, "yyyy-MM-dd").split("-").join("")
      ] = i;
      displayDate.setDate(displayDate.getDate() + 1);
    }
    return dateBlockNumMap
  }

  setBlockNumber() {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();

    let index;

    // if (currentHour > 17 || (currentHour === 17 && currentMinutes >= 30)) {
    //   // After 5:30 PM
    //   index = 2; // Today (Index 0: D-2, Index 1: D-1, Index 2: Today)
    // } else {
      // Before 5:30 PM
      index = 2; // Today
    // }
    return index;
  }

  fetchTotData(dataA: any, dataB: any) {
    let objA: any = this.fetchObj(dataA);
    let objB: any = this.fetchObj(dataB);
    let keys: any = Object.keys(objA);
    let finalArr: any = [];
    let obj: any = {}
    for (let i: any = 0; i < keys.length; i++) {
      let obj: any = {};
      obj = { ...obj, ...objA[keys[i]] };
      let newArr: any = [];
      newArr = newArr.concat(objA[keys[i]]['table_data']);
      newArr = newArr.concat(objB[keys[i]]['table_data']);
      obj['table_data'] = this.concatenateDataByTimestamp(newArr);

      finalArr.push(obj);
    }
    return finalArr;
  }

  fetchObj(data: any) {
    let obj: any = {};
    for (let i: any = 0; i < data.length; i++) {
      obj[data[i]['uuid']] = data[i];
    }

    return obj;
  }

  concatenateDataByTimestamp(dataArray) {
    const groupedData = {};

    // Group data by timestamp
    dataArray.forEach(item => {
      const timestamp = item.timeStamp;
      const data = item.data;

      if (!groupedData[timestamp]) {
        groupedData[timestamp] = [data];
      } else {
        groupedData[timestamp].push(data);
      }
    });
    const concatenatedData = [];
    for (const timestamp in groupedData) {
      if (groupedData.hasOwnProperty(timestamp)) {
        const concatenatedObject = groupedData[timestamp].reduce((acc, curr) => {
          return { ...acc, ...curr };
        }, {});
        concatenatedData.push({ timeStamp: parseInt(timestamp), data: concatenatedObject });
      }
    }
    return concatenatedData;
  }
  deepClone(object:any): any {
    if (isEmptyField(object)) {
      return;
    }
    if (Array.isArray(object)) {
      return object.slice();
    }
    const cloneObj :any= {};
    const attributes = Object.keys(object);
    for (const attribute of attributes) {
      const property = object[attribute];

      if (typeof property === 'object') {
        cloneObj[attribute] = this.deepClone(property);
      } else {
        cloneObj[attribute] = property;
      }
    }
    return cloneObj;
  }
  // getForecastData(postData) {
  //   let promise = new Promise((resolve, reject) => {
  //     this.http.post(ProjConstants.API_URL + "comm/hw/getForecastData", postData).subscribe(data => {
  //       this.mandalData = data;
  //       resolve(data);
  //     },
  //       err => {
  //         reject(err);
  //       }
  //     );
  //   })
  //   return promise;
  //   // return this.http.post<any>(this.urlConstants.PLAY_URL + "comm/hw/getForecastData", options).pipe(
  //   //   catchError(this.errorHandler.handleError('Forecast Data', []))
  //   // );
  // }

  // getForecastData(postData: any): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this.http.post(ProjConstants.API_URL + "comm/hw/getForecastData", postData).subscribe(data => {
  //       resolve(data);
  //     }, err => {
  //       reject(err);
  //     });
  //   });
  // }

  getForecastData(postData): Observable<any> {
    return this.http.post(ProjConstants.API_URL + "hw/getForecastData", postData)
      .pipe(
        catchError(this.errorHandler.handleError('Forecast Data', []))
      );
  }


  getHeatWatchesCount(postData): Observable<any> {
    return this.http.post(ProjConstants.API_URL + "heatWatches/getHeatWatchesCount", postData)
      .pipe(
        catchError(this.errorHandler.handleError('Heat Watches Count', []))
      );
  }

  getHWAccuracyData(postData): Observable<any> {
    return this.http.post(ProjConstants.API_URL + "hw/getHWAccuracyData", postData)
      .pipe(
        catchError(this.errorHandler.handleError('HW Accuracy Data', []))
      );
  }
  getActualTemperatureData(postData): Observable<any> {
    return this.http.post(ProjConstants.API_URL + "heatWatches/getActualTemperatureData", postData)
      .pipe(
        catchError(this.errorHandler.handleError('actual Temperature Data', []))
      );
  }


  public getFeatureInfo(latlng: any, layer: any, map: any) {
    let url = this.getFeatureInfoUrl(latlng, layer, map);
    return this.http.get(url).pipe(
      catchError((err) => {
        return EMPTY;
      })
    );
  }
  public getFeatureInfoUrl(latlng: any, layer: any, map: any) {
    // if(!isNullOrUndefined(latlng.latlng)){
    //   latlng = latlng.latlng
    // }
    let point = map.latLngToContainerPoint(latlng, map.getZoom());
    let size = map.getSize();
    let params: any = {
      request: 'getFeatureInfo',
      service: 'WMS',
      srs: 'EPSG:4326',
      transparent: true,
      version: layer ? layer.wmsParams.version : '',
      format: layer ? layer.wmsParams.format : '',
      bbox: map.getBounds().toBBoxString(),
      height: Math.floor(size.y),
      width: Math.floor(size.x),
      layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
      query_layers: layer ? layer.wmsParams.layers : '',//queryLayers.join(','),
      info_format: 'application/json',
      feature_count: 50,
      VIEWPARAMS: layer ? (layer.wmsParams.VIEWPARAMS ? layer.wmsParams.VIEWPARAMS : '1=1') : ''
      // CQL_FILTER: layer ? (layer.wmsParams.cql_filter ? layer.wmsParams.cql_filter : '1=1') : ''
    };
    params[params.version === '1.3.0' ? 'i' : 'x'] = Math.floor(point.x);
    params[params.version === '1.3.0' ? 'j' : 'y'] = Math.floor(point.y);
    let url = layer._url + (L as any).Util.getParamString(params, layer._url, true);
    return url;
  }
}
